import { ComponentProps, FC, ReactNode, useEffect, useState } from 'react';
import CameraIcon from '../../../assets/icons/camera.svg?react';
import styles from './ImageInput.module.css';
import CloseIcon from '../../../assets/icons/close.svg?react';
import { FormattedMessage, useIntl } from 'react-intl';
import { MAX_FILES } from './constants';
export interface AddPhotoButtonTextProps {
  children?: ReactNode;
}

export const AddPhotoButtonText: FC<AddPhotoButtonTextProps> = ({
  children,
}) => (
  <label className={styles.addPhoto}>
    {children}
    <CameraIcon className={styles.icn} />
    <FormattedMessage tagName="span" id="Photo.Add" />
  </label>
);

export interface FileInputProps
  extends Pick<ComponentProps<'input'>, 'onChange'> {}

export const HiddenImageInput: FC<FileInputProps> = (props) => (
  <input
    className={styles.file}
    multiple={MAX_FILES > 1}
    type="file"
    name="file"
    data-testid="upload-image"
    {...props}
  />
);

export interface ImageProps {
  file: File;
  onClose: () => void;
}

const toBase64String = (file: File): Promise<string> =>
  new Promise<string>((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      resolve(reader.result as string);
    });
    reader.readAsDataURL(file);
  });

export const Image: FC<ImageProps> = ({ file, onClose }) => {
  const { $t } = useIntl();
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    (async () => setSrc(await toBase64String(file)))();
  }, [file]);

  return (
    <>
      {src && (
        <div className={styles.imageContainer}>
          <div
            className={styles.imageClose}
            onClick={onClose}
            title={$t({ id: 'Photo.Remove' })}
          >
            <CloseIcon className={styles.icn} />
          </div>
          <img className={styles.image} src={src} alt={file.name} />
        </div>
      )}
    </>
  );
};
